import { useState } from 'react';
import { useRepo } from '../useStore.js';
import { fmt, goalPct, spaceWords, wc } from './util.js';

export default function Goals({ space, onDeleted }) {
  const repo = useRepo();
  const [confirming, setConfirming] = useState(false);
  if (!space) return null;

  const total = spaceWords(space);
  const pct = goalPct(space);
  const patch = field => e => repo.patchSpace(space.id, { [field]: e.target.value });

  return (
    <div className="pane">
      <div className="goals-col">
        <h2 className="pane-title">Tools &amp; Settings for this Space</h2>
        <p className="pane-sub">What this space is, a target for it, and where every document stands.</p>

        <div className="goal-card space-form">
          <label className="space-field">
            <span>Name</span>
            <input
              value={space.name} placeholder="Untitled space"
              autoFocus={!space.name}
              onFocus={e => { if (!space.name) e.target.select(); }}
              onChange={patch('name')}
            />
          </label>
          <label className="space-field">
            <span>Kind</span>
            <input value={space.kind} placeholder="Novel, Journal, Essays…" onChange={patch('kind')} />
          </label>
          <label className="space-field">
            <span>Description</span>
            <textarea value={space.description} placeholder="What is this space for?" onChange={patch('description')} />
          </label>
        </div>

        <div className="goal-card">
          <div className="goal-top">
            <span className="goal-total">{fmt(total)}</span>
            <span className="goal-of">of</span>
            <input
              className="goal-input" type="number" min="0" aria-label="Word goal"
              value={space.goal}
              onChange={e => repo.patchSpace(space.id, { goal: Math.max(0, parseInt(e.target.value, 10) || 0) })}
            />
            <span className="goal-of">words</span>
            <div className="spacer" />
            <span className="goal-pct-lg">{pct}%</span>
          </div>
          <div className="track-lg"><div style={{ width: pct + '%' }} /></div>
        </div>

        <div className="doc-rows">
          {space.docs.map(d => (
            <div className="doc-row" key={d.id}>
              <span className="t">{d.title || 'Untitled'}</span>
              <span className="w">{fmt(wc(d.content))} words</span>
            </div>
          ))}
        </div>

        <div className="danger">
          {!confirming ? (
            <button className="danger-btn" onClick={() => setConfirming(true)}>Delete this space</button>
          ) : (
            <div className="danger-confirm">
              <p>
                Delete <strong>{space.name || 'this space'}</strong> and its {space.docs.length}{' '}
                document{space.docs.length === 1 ? '' : 's'}
                {space.notes.length ? ` and ${space.notes.length} note${space.notes.length === 1 ? '' : 's'}` : ''}?
                {total > 0 && <> That is {fmt(total)} words. Export a backup first if you might want them.</>}
              </p>
              <div className="danger-row">
                <button className="danger-btn is-armed" onClick={() => { repo.removeSpace(space.id); onDeleted(); }}>
                  Yes, delete it
                </button>
                <button className="link-btn" onClick={() => setConfirming(false)}>Keep it</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
